import React from 'react';
import { Form, Input, Button, Row, Col } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import MomentDatePicker from '../MomentDatePicker';

const { TextArea } = Input;

const VaccinationHistorySection = () => {
  const { t } = useTranslation();

  return (
    <Form.List name="vaccinationHistory">
      {(fields, { add, remove }) => (
        <>
          {fields.map(({ key, name, ...restField }) => (
            <div key={key} className="medical-history-item">
              <Row gutter={[16, 0]}>
                <Col xs={24} sm={8}>
                  <Form.Item
                    {...restField}
                    name={[name, 'vaccineName']}
                    label={t('intake.medicalHistory.vaccinationHistory.fields.vaccineName')}
                    rules={[
                      { required: true, message: t('intake.medicalHistory.vaccinationHistory.validation.vaccineNameRequired') },
                      { max: 200, message: t('intake.medicalHistory.vaccinationHistory.validation.vaccineNameMaxLength') }
                    ]}
                  >
                    <Input placeholder={t('intake.medicalHistory.vaccinationHistory.placeholders.vaccineName')} />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={6}>
                  <Form.Item
                    {...restField}
                    name={[name, 'administeredDate']}
                    label={t('intake.medicalHistory.vaccinationHistory.fields.administeredDate')}
                  >
                    <MomentDatePicker
                      style={{ width: '100%' }}
                      placeholder={t('intake.medicalHistory.vaccinationHistory.placeholders.selectDate')}
                      format="MM/DD/YYYY"
                      disabledDate={(current) => current && current > moment().endOf('day')}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={6}>
                  <Form.Item
                    {...restField}
                    name={[name, 'administrator']}
                    label={t('intake.medicalHistory.vaccinationHistory.fields.administrator')}
                  >
                    <Input placeholder={t('intake.medicalHistory.vaccinationHistory.placeholders.administrator')} />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={4}>
                  <div className="remove-item-button" style={{ marginTop: '30px' }}>
                    <Button
                      type="text"
                      danger
                      icon={<MinusCircleOutlined />}
                      onClick={() => remove(name)}
                    >
                      {t('intake.medicalHistory.vaccinationHistory.buttons.remove')}
                    </Button>
                  </div>
                </Col>
              </Row>

              <Row gutter={[16, 0]}>
                <Col xs={24} sm={6}>
                  <Form.Item
                    {...restField}
                    name={[name, 'lotNumber']}
                    label={t('intake.medicalHistory.vaccinationHistory.fields.lotNumber')}
                  >
                    <Input placeholder={t('intake.medicalHistory.vaccinationHistory.placeholders.lotNumber')} />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={6}>
                  <Form.Item
                    {...restField}
                    name={[name, 'site']}
                    label={t('intake.medicalHistory.vaccinationHistory.fields.site')}
                  >
                    <Input placeholder={t('intake.medicalHistory.vaccinationHistory.placeholders.site')} />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item
                    {...restField}
                    name={[name, 'notes']}
                    label={t('intake.medicalHistory.vaccinationHistory.fields.notes')}
                  >
                    <TextArea
                      rows={1}
                      placeholder={t('intake.medicalHistory.vaccinationHistory.placeholders.notes')}
                      maxLength={300}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </div>
          ))}

          <Form.Item>
            <Button
              type="dashed"
              onClick={() => add()}
              block
              icon={<PlusOutlined />}
            >
              {t('intake.medicalHistory.vaccinationHistory.buttons.add')}
            </Button>
          </Form.Item>

          {fields.length === 0 && (
            <div className="no-items-message">
              <p>{t('intake.placeholders.noVaccinations')}</p>
            </div>
          )}
        </>
      )}
    </Form.List>
  );
};

export default VaccinationHistorySection;
